<template>
    <div>
        Aba Atendimento
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            msgs: [],
        }
    },
}
</script>

<style lang="scss">
</style>

